import {
    Box,
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    IconButton,
} from "@material-ui/core";
import Close from "@material-ui/icons/Close";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Constant } from "../../Constant";
export default function CustomHotlineDialog({
    formId,
    popupHotLineTitle,
    onClose,
}) {
    const { t, i18n } = useTranslation();
    const [popupHotLineDetail, setpopupHotLineDetail] = useState(null);

    useEffect(() => {
        showInfo(formId);
    }, [formId]);
    function showInfo(formId) {
        var hotlineArr = Constant.formHotLine
            .filter((x) => x.id === formId)
            .map((x) => x);
        setpopupHotLineDetail(
            hotlineArr.length === 0
                ? null
                : {
                      hotline: hotlineArr[0].hotline,
                      section: hotlineArr[0].section,
                      specialSentence: hotlineArr[0].specialSentence,
                  }
        );
    }
    const addWording = (msg, phoneMsg, phoneNum, section) => {
        if (phoneNum) {
            phoneMsg = phoneMsg.replace("#", phoneNum);
            msg = msg.replace("#", phoneMsg);
        } else {
            msg = msg.replace("#", "");
        }
        if (section) {
            msg = msg.replace("%", section);
        }
        return msg;
    };
    return (
        <Dialog
            open={formId > 0}
            onClose={onClose}
            aria-describedby="alert-dialog-description"
        >
            <IconButton
                aria-label="cancel"
                style={{
                    position: "absolute",
                    right: "5px",
                    top: "5px",
                    padding: "3px",
                }}
                onClick={onClose}
            >
                <Close />
            </IconButton>
            <DialogTitle
                style={{
                    padding: "60px 35px",
                    paddingBottom: "20px",
                    textAlign: "left",
                }}
            >
                {formId === 99999 || formId === 0
                    ? popupHotLineTitle
                    : t("common.formTitle", {
                          formId: formId + ": ",
                          formName: popupHotLineTitle,
                      })}
            </DialogTitle>
            <DialogContent
                style={{
                    padding: "0 35px 60px",
                }}
            >
                <Box id="alert-dialog-description">
                    {popupHotLineDetail && popupHotLineDetail.hotline != "0" && (
                        <>
                            {popupHotLineDetail.specialSentence && (
                                <Box
                                    style={{
                                        textAlign: "left",
                                        fontSize: "1.25rem",
                                    }}
                                    dangerouslySetInnerHTML={{
                                        __html: t(
                                            `hotline.specialSentence.${popupHotLineDetail.specialSentence}`
                                        ),
                                    }}
                                ></Box>
                            )}
                            <Box
                                style={{
                                    textAlign: "left",
                                    fontSize: "1.25rem",
                                }}
                            >
                                {!popupHotLineDetail.specialSentence &&
                                    addWording(
                                        t(
                                            `common.sideNavList.dialogFormHotline`
                                        ),
                                        t(`common.sideNavList.dialogFormTel`),
                                        popupHotLineDetail.hotline,
                                        t(
                                            `hotline.section.${popupHotLineDetail.section}`
                                        )
                                    )}
                            </Box>
                            <br />
                        </>
                    )}
                    <DialogContentText
                        style={{
                            textAlign: "left",
                            fontSize: "1.25rem",
                        }}
                    >
                        {t(`common.sideNavList.dialogHotline`)}
                        <br />
                        {addWording(
                            t(`common.sideNavList.dialogHotline2`),
                            t(`common.sideNavList.dialogFormTel`),
                            t("hotline.common")
                        )}
                        <br />
                        <br />
                        {t(`common.sideNavList.dialogServiceHours`)}
                        <br />
                        {t(`common.sideNavList.dialogServiceHours2`)}
                    </DialogContentText>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
